// Importa dependências necessárias
import axios from "axios";
import React, { useState } from "react";
import { Link } from 'react-router-dom';
import Imagens from "../../img/imagens";

// URL base da API
//const baseUrl = "https://localhost:44304/api";  //API de DEV
const baseUrl = "http://10.80.12.5:81/api"; // API de Produção

// Componente principal do formulário de chamado ADM
const ChamadoADMForm = () => {
  // Estado para os campos do formulário
  const [formData, setFormData] = useState({
    nome: "",
    rf: "",
    unidade: "",
    prioridade: "",
    servico: "",
    descricao: ""
  });

  // Estado para imagem em base64
  const [imagem, setImagem] = useState(null);
  // Estado para controle de envio
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Estado para exibir modal de sucesso
  const [showModal, setShowModal] = useState(false);

  // Manipula mudanças nos campos do formulário
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Manipula upload de arquivo e converte para base64
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    
    reader.readAsDataURL(file); // Lê como Base64
    reader.onload = () => {
      setImagem(reader.result.split(",")[1]); // Remove o prefixo 'data:image/...'
    };
  };

  // Manipula o envio do formulário
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
  
    try {
      const chamadoData = { ...formData, Imagem: imagem }; // base64
  
      // 1. Envia o e-mail
      await axios.post(`${baseUrl}/EmailADM/send`, chamadoData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      // 2. Salva o chamado no backend
      await axios.post(`${baseUrl}/ChamadoADM`, chamadoData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      setShowModal(true);
    } catch (error) {
      console.error("Erro ao criar chamado ou enviar e-mail:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Renderização do componente
  return (
    <div className="container mt-5">
      <header className="App-header">
        <a href='https://www.prefeitura.sp.gov.br/cidade/secretarias/controladoria_geral/' target='blank' rel="noopener noreferrer" className='logolink'>
          <img src={Imagens.CGM1} alt="Prefeitura" width="150" className='logo' />
        </a>
        {/* Botão de voltar */}
        <div className='Voltar'>
          <Link className='voltarbtn' to="/">
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" fill="currentColor" class="bi bi-arrow-return-left" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M14.5 1.5a.5.5 0 0 1 .5.5v4.8a2.5 2.5 0 0 1-2.5 2.5H2.707l3.347 3.346a.5.5 0 0 1-.708.708l-4.2-4.2a.5.5 0 0 1 0-.708l4-4a.5.5 0 1 1 .708.708L2.707 8.3H12.5A1.5 1.5 0 0 0 14 6.8V2a.5.5 0 0 1 .5-.5" />
            </svg>
            <p> &nbsp; Voltar a tela inicial</p>
          </Link>
        </div>
      </header>
      {/* Título */}
      <h1 className="text-center mb-4" style={{ color: "#EC6608", marginTop: "100px", fontWeight: "bold", animation: "fadeIn 1s ease-in-out" }}>
            Registrar Chamado DADM
        </h1>
        {/* Formulário de chamado */}
        <form
            onSubmit={handleSubmit}
            className="p-4 border rounded shadow-lg"
            style={{ backgroundColor: "#FFF7F0", borderColor: "#EC6608", maxWidth: "600px", margin: "0 auto" }}
        >
            {/* Campo Nome */}
            <div className="mb-3">
                <label htmlFor="nome" className="form-label fw-bold">
                    Nome
                </label>
                <input
                    type="text"
                    className="form-control border-2"
                    id="nome"
                    name="nome"
                    value={formData.nome}
                    onChange={handleChange}
                    placeholder="Digite seu nome"

                />
            </div>

            {/* Campo RF */}
            <div className="mb-3">
                <label htmlFor="rf" className="form-label fw-bold">
                    RF
                </label>
                <input
                    type="text"
                    className="form-control border-2"
                    id="rf"
                    name="rf"
                    value={formData.rf}
                    onChange={handleChange}
                    placeholder="Digite seu RF"
                />
            </div>

            {/* Campo Unidade */}
            <div className="mb-3">
                <label htmlFor="unidade" className="form-label fw-bold">
                    Unidade
                </label>
                <select
                    className="form-select border-2"
                    id="unidade"
                    name="unidade"
                    value={formData.unidade}
                    onChange={handleChange}
                >
                    <option value="" disabled>Selecione uma unidade</option>
                    <option value="Gabinete do Controlador">Gabinete do Controlador</option>
                    <option value="Assessoria de Produção de Informações e Inteligência">Assessoria de Produção de Informações e Inteligência</option>
                    <option value="Assessoria Técnica">Assessoria Técnica</option>
                    <option value="Assessoria Jurídica">Assessoria Jurídica</option>
                    <option value="Assessoria de Comunicação">Assessoria de Comunicação</option>
                    <option value="Corregedoria Geral">Corregedoria Geral</option>
                    <option value="Coordenadoria de Promoção da Integridade e Boas Práticas">Coordenadoria de Promoção da Integridade e Boas Práticas</option>
                    <option value="Auditoria Geral">Auditoria Geral</option>
                    <option value="Ouvidoria Geral">Ouvidoria Geral</option>
                    <option value="Coordenadoria de Defesa do Usuário do Serviço Público Municipal">Coordenadoria de Defesa do Usuário do Serviço Público Municipal</option>
                    <option value="Coordenadoria de Administração e Finanças">Coordenadoria de Administração e Finanças</option>
                    <option value="Coordenadoria de Proteção de Dados Pessoais">Coordenadoria de Proteção de Dados Pessoais</option>
                </select>
            </div>

            {/* Campo Prioridade */}
            <div className="mb-3">
                <label htmlFor="prioridade" className="form-label fw-bold">
                    Prioridade
                </label>
                <select
                    className="form-select border-2"
                    id="prioridade"
                    name="prioridade"
                    value={formData.prioridade}
                    onChange={handleChange}
                >
                    <option value="">Selecione a prioridade</option>
                    <option value="Baixa">Baixa</option>
                    <option value="Média">Média</option>
                    <option value="Alta">Alta</option>
                </select>
            </div>

            {/* Campo Serviço */}
            <div className="mb-3">
                <label htmlFor="servico" className="form-label fw-bold">
                    Serviço
                </label>
                <select
                    className="form-select border-2"
                    id="servico"
                    name="servico"
                    value={formData.servico}
                    onChange={handleChange}
                >
                    <option value="" disabled>Selecione um serviço</option>
                    <option value="Reparos/manutenção">Reparos/manutenção</option>
                    <option value="Solicitação de carimbos">Solicitação de carimbos</option>
                    <option value="Solicitação de chaves">Solicitação de chaves</option>
                    <option value="Emissão de passagens aéreas">Emissão de passagens aéreas</option>
                    <option value="Solicitação de coffee break">Solicitação de coffee break</option>
                    <option value="Solicitação de bilhete único">Solicitação de bilhete único</option>
                </select>
            </div>

            {/* Mensagem informativa do serviço */}
            {formData.servico && (
                <div className="mt-2">
                    <p
                        className="text-muted rounded p-3"
                        style={{
                            backgroundColor: "#FBE3D9",
                            borderLeft: "5px solid #EC6608",
                        }}
                    >
                        {formData.servico === "Reparos/manutenção" &&
                            "Este serviço inclui solicitações relacionadas a consertos, reparos em instalações e manutenção geral."}
                        {formData.servico === "Solicitação de carimbos" &&
                            "Solicitações para confecção ou reposição de carimbos personalizados. Informe seu nome completo, RF, setor e anexe arte."}
                        {formData.servico === "Solicitação de chaves" &&
                            "Solicite a cópia ou reposição de chaves perdidas ou danificadas. Informe quem terá a posse da(s) cópia(s) e a justificativa."}
                        {formData.servico === "Emissão de passagens aéreas" &&
                            "Informe nome completo, CPF, data, destino e RF."}
                        {formData.servico === "Solicitação de coffee break" &&
                            "Organize coffee breaks para reuniões, eventos ou treinamentos. Informe detalhes do evento e quantitativo de pessoas."}
                        {formData.servico === "Solicitação de bilhete único" &&
                            "Solicite bilhete único para deslocamentos. Informe data, destino, motivo e quantidade de passagens."}
                    </p>
                </div>
            )}

            {/* Campo Descrição */}
            <div className="mb-3">
                <label htmlFor="descricao" className="form-label fw-bold">
                    Descrição
                </label>
                <textarea
                    className="form-control border-2"
                    id="descricao"
                    name="descricao"
                    value={formData.descricao}
                    onChange={handleChange}
                    rows="4"
                    placeholder="Digite a descrição do chamado"
                ></textarea>
            </div>

            {/* Upload de imagem */}
            <div className="mb-3">
                <label htmlFor="imagem" className="form-label fw-bold">
                    Upload de Imagem (Caso necessário) em formato .jpg
                </label>
                <input
                    type="file"
                    className="form-control border-2"
                    id="imagem"
                    name="imagem"
                    accept="image/*"
                    onChange={handleFileChange}
                />
            </div>

            {/* Botão de envio */}
            <button
                type="submit"
                className="btn w-100 fw-bold"
                style={{
                    backgroundColor: "#EC6608",
                    color: "#FFFFFF",
                    borderColor: "#EC6608",
                    transition: "0.3s",
                }}
                disabled={isSubmitting}
                onMouseOver={(e) => (e.target.style.backgroundColor = "#d95a07")}
                onMouseOut={(e) => (e.target.style.backgroundColor = "#EC6608")}
            >
                {isSubmitting ? "Enviando..." : "Registrar Chamado"}
            </button>
        </form>

      {/* Modal de sucesso */}
      {showModal && (
        <div className="modal d-block" style={{ backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Chamado Criado</h5>
              </div>
              <div className="modal-body">
                <p>Seu chamado foi registrado com sucesso!</p>
              </div>
              <div className="modal-footer">
                <Link className='btn btn-primary' to="/">Voltar ao Menu Inicial</Link>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* Estilo para animação */}
      <style>
        {`
          @keyframes fadeIn {
            from { opacity: 0; transform: translateY(-10px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>
    </div>
    
  );
};

// Exporta o componente principal
export default ChamadoADMForm;

